module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/resonio/startpage_de-d5f3428606c79b70e18ab6ddbdc417b8.gif";